import React, { useMemo } from 'react';
import { get } from 'lodash';
import useGetSavedDashboard from '@components/saving/useGetSavedDashboard';
import Retry from '../Retry';
import { getPageKeyForSaveService } from '@utils/savedDashboard';
import { createStore } from 'jotai';

function SavedDashboardHOC({ children, applySavedData, initStore = createStore, ...props }) {
  const { match } = props;
  const id = `${get(match, 'params.id', '')}`;
  const pageKeyForSaveService = getPageKeyForSaveService('saved', id, null);

  const {
    isLoading,
    isError,
    refetch,
    savedData = {},
    isSavedDataApplied,
  } = useGetSavedDashboard(id, pageKeyForSaveService, applySavedData);

  // intialize jotai store with default state
  // reusing share init as parameters for save/share are same
  const store = useMemo(() => {
    if (!isLoading) {
      const state = get(savedData, ['config', 'state'], {});
      return initStore(state);
    }
    return null;
  }, [savedData, isLoading, initStore]);

  const childrenProps = {
    ...props,
    isSavedDashboard: true,
    savedDashboardCreatorId: savedData.creatorId,
    store,
  };

  return (
    <Retry
      fetchData={refetch}
      // wait for apply to happen before rendering
      isLoading={isLoading && !isSavedDataApplied}
      showError={isError}
      progress={true}
      mountChildAlways={false}
    >
      <>{children(childrenProps)}</>
    </Retry>
  );
}

export default SavedDashboardHOC;
